var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 13.3337C14.9468 13.3337 17.3346 10.9458 17.3346 8.00033C17.3346 5.05481 14.9468 2.66699 12.0013 2.66699C9.05578 2.66699 6.66797 5.05481 6.66797 8.00033C6.66797 10.9458 9.05578 13.3337 12.0013 13.3337Z",
    fill: "#B9FF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 28.0016C17.156 28.0016 21.3346 25.6138 21.3346 22.6683C21.3346 19.7228 17.156 17.335 12.0013 17.335C6.84664 17.335 2.66797 19.7228 2.66797 22.6683C2.66797 25.6138 6.84664 28.0016 12.0013 28.0016Z",
    fill: "#B9FF66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 22.667C27.9999 24.8761 25.2859 26.6669 21.9722 26.6669C22.9485 25.5998 23.6198 24.2603 23.6198 22.6687C23.6198 21.0754 22.9469 19.7347 21.9688 18.667C25.2825 18.667 27.9999 20.4578 27.9999 22.667Z",
    fill: "#B9FF66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 8.00098C24.0001 10.2101 22.2093 12.001 20.0001 12.001C19.5184 12.001 19.0566 11.9158 18.6289 11.7597C19.2597 10.6503 19.62 9.36696 19.62 7.9995C19.62 6.63303 19.2602 5.35059 18.6302 4.2417C19.0576 4.08595 19.5189 4.00098 20.0001 4.00098C22.2093 4.00098 24.0001 5.79184 24.0001 8.00098Z",
    fill: "#B9FF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e3c0b3c23087791f4ba03e9b6ed788d8.svg";
export { ForwardRef as ReactComponent };